import { render } from "./WayOfPayment.vue?vue&type=template&id=4f46289e&scoped=true"
import script from "./WayOfPayment.vue?vue&type=script&lang=js"
export * from "./WayOfPayment.vue?vue&type=script&lang=js"

import "./WayOfPayment.vue?vue&type=style&index=0&id=4f46289e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f46289e"]])

export default __exports__